// extracted by mini-css-extract-plugin
export default {"wrapper":"PasswordStrengthBar_wrapper__s7vO5","label":"PasswordStrengthBar_label__3aZzx","body":"PasswordStrengthBar_body__JQL9D"};